import { Area, HealthCenter, Unit } from '@silbo/core';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAuthenticationContext } from '../../../contexts/AuthenticationContext';
import { getHealthCenterUnitsQueryOptions } from '../queries';
import { unitOfBedFrom } from '../utils/unit-of-bed';

/** L'unité d'un lit, lue dans les unités de l'établissement déjà chargées par la liste. */
export const useUnitOfBed = (): ((bed: Area) => Unit | undefined) => {
  const { healthCenter } = useAuthenticationContext();
  const { data: units = [] } = useQuery({
    ...getHealthCenterUnitsQueryOptions(healthCenter as HealthCenter),
    enabled: !!healthCenter,
    // Sans ça, chaque ouverture relit toutes les unités par lots ; le retour sur l'application les relit déjà.
    refetchOnMount: false,
  });
  return useMemo(() => unitOfBedFrom(units), [units]);
};
